import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Star, ArrowRight, CheckCircle } from 'lucide-react';

const ReviewsPage = () => {
  const reviews = [
    {
      id: 'casino-casino',
      name: 'Casino Casino',
      bonus: '100% Bonus up to £100',
      rating: 4.5,
      description: 'A trusted UK operator offering solid game selection, reliable payouts, and straightforward bonus terms.',
      image: '/images/stephan-coudassot-saitqe6-Oyo-unsplash.webp',
    },
    {
      id: 'magic-red',
      name: 'Magic Red',
      bonus: '100% up to £35 + 50 spins',
      rating: 4.3,
      description: 'Perfect for players seeking generous welcome packages with free spins and matched deposit bonuses.',
      image: '/images/ays-be-BD4pN-2zw7s-unsplash.webp',
    },
    {
      id: 'all-british-casino',
      name: 'All British Casino',
      bonus: '100% up to £100 + always 10% cashback',
      rating: 4.7,
      description: 'Standout operator offering exceptional ongoing value through cashback rewards and competitive bonuses.',
      image: '/images/ayush-kumar-5to5BOIwLPw-unsplash.webp',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <section className="py-16 md:py-24 bg-gradient-to-br from-gray-dark to-gray-medium text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <div className="flex items-center justify-center space-x-3 mb-6">
              <Star className="text-yellow-accent" size={40} />
              <h1 className="text-4xl md:text-5xl font-bold">Casino Reviews</h1>
            </div>
            <p className="text-xl text-gray-200 leading-relaxed">
              In-depth reviews of UK's top online casinos. We test, we verify, we recommend only the best.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-dark text-center mb-12">
            Featured Casino Reviews
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {reviews.map((review, index) => (
              <Link
                key={review.id}
                to={`/reviews/${review.id}`}
                data-discover="true"
                className={`bg-white border-2 border-gray-200 rounded-xl overflow-hidden hover:border-yellow-accent hover:shadow-lg transition-all transform hover:scale-105 ${
                  index === 0 ? 'border-yellow-accent' : ''
                }`}
              >
                <div 
                  className="h-48 bg-cover bg-center"
                  style={{ backgroundImage: `url(${review.image})` }}
                ></div>
                
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <h3 className="text-2xl font-bold text-gray-dark">{review.name}</h3>
                    <div className="flex items-center space-x-1">
                      <Star className="text-yellow-accent fill-yellow-accent" size={20} />
                      <span className="font-bold text-gray-dark">{review.rating}</span>
                    </div>
                  </div>
                  
                  <div className="mb-4">
                    <p className="text-sm text-gray-light mb-1">Welcome Bonus</p>
                    <p className="text-lg font-bold text-gray-dark">{review.bonus}</p>
                  </div>
                  
                  <p className="text-gray-light mb-4 leading-relaxed">
                    {review.description}
                  </p>
                  
                  <div className="inline-flex items-center space-x-2 text-yellow-accent font-semibold hover:text-yellow-light transition-colors">
                    <span>Read Full Review</span>
                    <ArrowRight size={16} />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-dark mb-6">How We Review Casinos</h2>
            
            <div className="prose prose-lg max-w-none text-gray-light leading-relaxed space-y-6">
              <p>
                Our casino reviews aren't marketing copy or paid promotions – they're comprehensive 
                evaluations based on real testing, genuine play, and honest assessment. We deposit 
                real money, play real games, process real withdrawals, and experience each casino 
                exactly as you would. This hands-on approach ensures our reviews reflect actual 
                player experiences, not theoretical knowledge or operator claims.
              </p>
              
              <p>
                Every review covers essential factors that impact your gaming experience. We test 
                game selection quality and variety, evaluating whether operators deliver on promises 
                about game libraries. We verify bonus terms, checking whether wagering requirements 
                are fair and achievable. We process withdrawals, measuring actual speeds against 
                advertised timeframes. We test customer support, evaluating response times and 
                helpfulness. We assess mobile experiences, ensuring games work smoothly on 
                smartphones and tablets.
              </p>
              
              <p>
                Our rating system considers multiple factors weighted by importance. Licensing and 
                security receive highest priority – without these, nothing else matters. Game 
                selection and quality follow, as these determine your entertainment value. Payment 
                methods and withdrawal speeds matter significantly, affecting how easily you can 
                access winnings. Bonus terms and transparency impact value, while customer support 
                quality matters when problems arise.
              </p>
              
              <p>
                We update reviews regularly as casinos evolve. Operators improve services, add new 
                games, change bonus terms, and enhance features. Our reviews reflect current states, 
                not outdated information from months ago. When casinos improve or decline, we update 
                our assessments accordingly, ensuring you receive accurate, current information.
              </p>
              
              <p>
                Transparency guides every review. We clearly explain our testing methods, disclose 
                our affiliate relationships, and never let commercial partnerships influence editorial 
                content. If a casino has problems, we report them honestly. If an operator excels, 
                we recognize achievements fairly. Our reputation depends on providing honest, 
                accurate reviews that help you make informed decisions.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ReviewsPage;

